export default __webpack_public_path__ + "static/step-2-done-bar-741e260ac90a16336244d31e38887ccc.svg";